import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { scrollToContact } from "@/lib/scroll";

const Header = () => (
  <motion.header
    data-testid="site-header"
    initial={{ y: -64, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    className="fixed inset-x-0 top-0 z-40 border-b border-[#E8DFC8] bg-[#FAF7F2]/85 backdrop-blur-xl"
  >
    <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3.5 sm:py-4">
      <div className="flex items-center gap-3.5">
        <img
          data-testid="header-ksr-logo"
          src="/logo.png"
          alt="KSR Poultry Farms logo"
          className="h-12 w-12 rounded-full object-cover shadow-[0_2px_8px_rgba(107,29,47,0.25)] sm:h-14 sm:w-14"
        />
        <div>
          <p data-testid="header-farm-title" className="font-display text-lg font-semibold leading-tight sm:text-xl">
            KSR Poultry Farms
          </p>
          <p className="font-mono-brand text-[11px] uppercase tracking-[0.2em] text-[#8C7A70] sm:text-xs">
            Mansampalle · Vikarabad
          </p>
        </div>
      </div>
      <button
        type="button"
        data-testid="header-call-link"
        onClick={scrollToContact}
        className="flex items-center gap-2 rounded-full border border-[#E5D1A6] bg-[#FAF3E6] px-4 py-2 text-xs font-semibold text-[#6B1D2F] transition-colors duration-300 hover:bg-[#6B1D2F] hover:text-[#FAF3E6] sm:px-5 sm:py-2.5 sm:text-sm"
      >
        <Phone size={14} strokeWidth={2.2} />
        <span className="hidden sm:inline">Contact</span>
      </button>
    </div>
  </motion.header>
);

export default Header;
